import { useStaticQuery, graphql } from 'gatsby';
import { builder } from '@builder.io/react';
import { useDynamicNavigation } from './useDynamicNavigation';

export function useBuilderNavigation() {
  const data = useStaticQuery(graphql`
    query {
      allBuilderModels {
        navigationLinks(options: { cachebust: true }) {
          data {
            link
            pathname
            navLink
          }
          id
        }
      }
    }
  `);
  
  const dynamicLinks = useDynamicNavigation();

  return {
    navigationLinks: (builder.editingMode$.value || builder.preview) 
      ? dynamicLinks 
      : data?.allBuilderModels?.navigationLinks
  };
}
